import { useDroppable } from '@dnd-kit/core';
import { Box, createStyles } from '@mantine/core';
import {
	HORIZONTAL_INDICATOR_ABOVE_ID_PREFIX,
	HORIZONTAL_INDICATOR_BELOW_ID_PREFIX,
	INDICATOR_SIZE,
	ROW_GAP,
} from './constants';

interface DnDHorizontalIndicatorProps {
	id: string;
	isFirstRow: boolean;
	isLastRow: boolean;
	readOnly?: boolean;
}

interface DnDHorizontalIndicatorStylesProps {
	isFirstIndicator: boolean;
	isLastIndicator: boolean;
	isOver: boolean;
}

const useStyles = createStyles(
	(
		theme,
		{
			isFirstIndicator,
			isLastIndicator,
			isOver,
		}: DnDHorizontalIndicatorStylesProps
	) => {
		let height = ROW_GAP;
		let paddingTop = `calc((${ROW_GAP}px - ${INDICATOR_SIZE}px) / 2)`;
		let paddingBottom = `calc((${ROW_GAP}px - ${INDICATOR_SIZE}px) / 2)`;
		if (isFirstIndicator) {
			paddingTop = `0`;
			height -= ROW_GAP / 2;
		}
		if (isLastIndicator) {
			paddingBottom = `0`;
			height -= ROW_GAP / 2;
		}
		return {
			wrapper: {
				height,
				padding: `${paddingTop} 0 ${paddingBottom} 0`,
			},
			indicator: {
				width: '100%',
				height: INDICATOR_SIZE,
				backgroundColor: theme.other.getColor('fill/emphasis/default'),
				borderRadius: theme.radius.md,
				visibility: isOver ? 'visible' : 'hidden',
			},
		};
	}
);

export function DnDHorizontalIndicator({
	id,
	isFirstRow,
	isLastRow,
	readOnly = false,
}: DnDHorizontalIndicatorProps) {
	const { setNodeRef, over } = useDroppable({
		id,
		disabled: readOnly,
	});

	const isFirstIndicator =
		isFirstRow && id.includes(HORIZONTAL_INDICATOR_ABOVE_ID_PREFIX);
	const isLastIndicator =
		isLastRow && id.includes(HORIZONTAL_INDICATOR_BELOW_ID_PREFIX);

	const { classes } = useStyles({
		isFirstIndicator,
		isLastIndicator,
		isOver: readOnly ? false : id === over?.id,
	});

	return (
		<Box ref={setNodeRef} className={classes.wrapper}>
			<Box className={classes.indicator} />
		</Box>
	);
}
